// Wrapper for localStorage in case we want to not rely on window in tests etc.
export default window.localStorage
